import { render } from "./LayoutContentRendererLeft.vue?vue&type=template&id=9786c78a"
import script from "./LayoutContentRendererLeft.vue?vue&type=script&lang=js"
export * from "./LayoutContentRendererLeft.vue?vue&type=script&lang=js"
script.render = render

export default script